// Sessão 1 Frente A — Severity indicator visual (bar/dot por range).
// Sincronizado com EventService::SeverityLabel backend:
//   <30  info     (gray)
//   30-69 suspect  (yellow)
//   70-89 high     (orange)
//   >=90 critical (red)

interface Props {
  severity: number;
  showLabel?: boolean;
  className?: string;
}

export function SeverityIndicator({ severity, showLabel = true, className = '' }: Props) {
  let color = 'bg-gray-500';
  let textColor = 'text-gray-300';
  let label = 'info';

  if (severity >= 90)      { color = 'bg-red-500';    textColor = 'text-red-300';    label = 'critical'; }
  else if (severity >= 70) { color = 'bg-orange-500'; textColor = 'text-orange-300'; label = 'high';     }
  else if (severity >= 30) { color = 'bg-yellow-500'; textColor = 'text-yellow-300'; label = 'suspect';  }

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span
        className={`inline-block w-2 h-2 rounded-full ${color}`}
        aria-label={`severity ${severity}`}
      />
      <span className={`text-xs font-medium ${textColor}`}>
        {severity}
        {showLabel && ` ${label}`}
      </span>
    </span>
  );
}

export default SeverityIndicator;
